import * as types from 'src/store/types';
export default {
  currentBrandInfo (state) {
    return state.available.find(o => o.id === state.current)
  }
};
